<template>
  <div class="consultant-popup-pc">
    <!-- 使用封装的 BasePopover 组件 -->
    <BasePopover
      :position="position"
      :trigger="trigger"
      :show-arrow="true"
      :popup-container="popupContainer"
      :popup-visible="debugVisible ? true : popupVisible"
      :overlay-style="{ zIndex: 1200 }"
      :auto-fit-position="true"
      :scroll-to-close="scrollToClose"
      :scroll-to-close-distance="scrollToCloseDistance"
      :content-style="{
        width: '328px',
        maxHeight: 'calc(100vh - 40px)',
        overflow: 'visible',
        padding: '24px 32px',
        boxSizing: 'border-box',
        background: '#fff',
        border: '1px solid #e5e6eb',
        borderRadius: '12px',
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
      }"
    >
      <!-- 触发按钮插槽 -->
      <template #content>
        <!-- 弹窗内容 -->
        <div class="popup-content">
          <!-- 弹窗主体 -->
          <div class="popup-body">
            <!-- 顾问组件 -->
            <div ref="consultantRef" class="consultant-container">
              <Consultant />
            </div>
          </div>
        </div>
      </template>

      <slot name="trigger">
        <button class="default-trigger-btn">
          <span>专属客服</span>
        </button>
      </slot>
    </BasePopover>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import BasePopover from '~/components/base/Popover.vue'
import Consultant from './Consultant.vue'
import { THEME_COLORS } from '~/utils/theme'

const props = defineProps({
  position: {
    type: String,
    default: 'top',
    validator: (value) =>
      ['top', 'tl', 'tr', 'bottom', 'bl', 'br', 'left', 'lt', 'lb', 'right', 'rt', 'rb'].includes(
        value
      ),
  },
  trigger: {
    type: String,
    default: 'hover',
    validator: (value) => ['hover', 'click', 'focus'].includes(value),
  },
  debugVisible: {
    type: Boolean,
    default: false,
  },
  popupVisible: {
    type: Boolean,
    default: undefined,
  },
  popupContainer: {
    type: [String, Object],
    default: undefined,
  },
  scrollToClose: {
    type: Boolean,
    default: false,
  },
  scrollToCloseDistance: {
    type: Number,
    default: 0,
  },
})

const emit = defineEmits(['close'])

const consultantRef = ref(null)

const closePopup = () => {
  emit('close')
}

const convertConsultantToImage = async () => {
  if (!consultantRef.value) return null

  try {
    const canvas = await html2canvas(consultantRef.value, {
      useCORS: true,
      scale: 2,
      backgroundColor: THEME_COLORS.bgSurface,
    })

    const imageDataUrl = canvas.toDataURL('image/png')
    return imageDataUrl
  } catch (error) {
    console.error('转换图片失败:', error)
    return null
  }
}

const shareToWechat = async () => {
  // 确保只在客户端环境中执行
  if (!import.meta.client) return

  const imageDataUrl = await convertConsultantToImage()
  if (!imageDataUrl) {
    alert('生成图片失败，请稍后重试')
    return
  }

  const img = new Image()
  img.src = imageDataUrl

  const newWindow = window.open('', '_blank')
  newWindow.document.write(
    `<html><body style="margin:0; padding:20px; background-color:${THEME_COLORS.bgSoft}; text-align:center;"><h3 style="margin-bottom:20px;">请长按图片转发给微信好友</h3><img src="${imageDataUrl}" style="max-width:100%; border-radius:8px; box-shadow:0 2px 12px rgba(0,0,0,0.1);" /></body></html>`
  )
  newWindow.document.close()
}

const saveToLocal = async () => {
  // 确保只在客户端环境中执行
  if (!import.meta.client) return

  const imageDataUrl = await convertConsultantToImage()
  if (!imageDataUrl) {
    alert('生成图片失败，请稍后重试')
    return
  }

  const link = document.createElement('a')
  link.download = '专属顾问.png'
  link.href = imageDataUrl

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

defineExpose({
  shareToWechat,
  saveToLocal,
  closePopup,
})
</script>

<style lang="scss" scoped>
.consultant-popup-pc {
  position: relative;
  display: inline-block;
  width: 100%;

  .popup-content {
    width: 100%;
    box-sizing: border-box;

    .popup-body {
      width: 100%;
      .consultant-container {
        width: 100%;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
